import Configs from '@/configs'

const appName = Configs.APP_NAME

const dashboardFaqs = [
  {
    question: 'How long is the free storage?',
    answer: [
      'You can enjoy free storage for 6 months if you use our shipping services from your location to our warehouse and from our warehouse back to you. Free storage starts as soon as your packages are delivered to us. You can continue storing after the free 6 months, but the storage fee of $10 per package per month will start applying.',
      'If you only use our shipping services once, free storage does not apply, and you will be charged a storage fee of $10 per package monthly. For example, if you only ship to us to pick up later in person or drop off in person at our location to ship to you later, free storage does not apply.'
    ]
  },
  {
    question: 'How much is the extra storage time?',
    answer: [
      'If you wish to continue storing items beyond the complimentary 6 months, the storage fee is $10/package/month.',
      'Please note that there is no free storage if you do not use our shipping services for both sending packages to us and receiving packages from us. The storage fee will apply as soon as your packages are delivered to us.'
    ]
  },
  {
    question: 'Can I pick up from the storage facility?',
    answer: [
      'Yes, you can come in person to pick up your packages from the facility. Please inform us at least 2 business days in advance so that we can have your packages ready for pickup.',
      'Please be aware that if you choose this service, free storage does not apply, and you will be charged the storage fee of $10 per package per month from the time your packages are stored until you pick them up.'
    ]
  },
  {
    question: 'Can I drop off to the storage facility?',
    answer: [
      'Yes, you can walk in and drop off your packages at our storage facility and have them shipped to you whenever you need.',
      'Please note that if you choose this service, free storage does not apply, and you will be charged a storage fee of $10 per package per month from the time your packages are dropped off at our facility until they are shipped to you.'
    ]
  },
  {
    question: 'What payment methods do you accept?',
    answer: [
      'All payments are made online using debit or credit cards such as Visa, Mastercard, AMEX, Discover, and others.'
    ]
  },
  {
    question: 'Why is the shipping rate different?',
    answer: ['Three factors affect shipping: distance (shipping from and to), package size (L x W x H), and weight.']
  },
  {
    question: 'Can I ship my packages separately?',
    answer: [
      'Yes. If your packages are going to or coming from different storage facilities, please place separate shipping orders. You can ship your packages together in the same order if they are going to or coming from the same storage facility.'
    ]
  },
  {
    question: 'How much is the return shipping cost?',
    answer: [
      'If you are sending the exact same packages back to the original zip code, the cost will remain the same. If you are shipping different packages or to a different location, please visit our website to obtain a quotation.'
    ]
  }
]

const myShipmentFaqs = [
  {
    question: 'How do I ensure accurate shipping costs?',
    answer: [
      'Properly inputting package dimensions is crucial to calculating accurate shipping costs. Make sure to provide accurate length, width, and height measurements for each package.'
    ]
  },
  {
    question: 'What should I do if my shipment is incomplete?',
    answer: [
      "If your shipment is incomplete, please check the status of each item in your order. Contact customer support if you believe there's an error or missing item."
    ]
  },
  {
    question: 'How can I track the status of my processing shipments?',
    answer: [
      'You can track the status of your processing shipments in real-time through your account dashboard. Updates will be provided as your items move through our processing system.'
    ]
  },
  {
    question: 'Where can I find my shipment history?',
    answer: [
      'Your shipment history, including past orders and tracking information, can be accessed through the <strong>"Shipment History"</strong> section of your account.'
    ]
  },
  {
    question: "Can I modify or cancel after it's been processed?",
    answer: [
      'Once a shipment has been processed, modifications or cancellations may not be possible. Please contact customer support immediately if you need assistance with a processed shipment.'
    ]
  },
  {
    question: 'Can I consolidate multiple shipments into one order?',
    answer: [
      'Yes, you can consolidate multiple shipments into a single order if they are being sent to the same destination. This helps optimize shipping costs and delivery efficiency.'
    ]
  },
  {
    question: 'What happens if lost or damaged during transit?',
    answer: [
      'In the rare event that your shipment is lost or damaged during transit, please contact our customer support immediately. We will initiate an investigation and work to resolve the issue promptly.'
    ]
  },
  {
    question: 'Is there insurance available for my shipments?',
    answer: [
      'Yes, you have the option to purchase shipping insurance for your shipments. This provides added protection against loss or damage during transit. Contact customer support for more information on insurance options.'
    ]
  }
]

const myStorageFaqs = [
  {
    question: 'How long can I store my items?',
    answer: [
      'You can store your items for up to 6 months free of charge if you use our shipping services both ways. After the complimentary period, a storage fee of $10 per package per month will apply.'
    ]
  },
  {
    question: 'What if I only need one-way shipping?',
    answer: [
      'If you only require shipping in one direction (either to our warehouse or from our warehouse), free storage does not apply, and the storage fee will be charged once your packages are received.'
    ]
  },
  {
    question: 'How do I request items to be prepared for shipping?',
    answer: [
      'If you wish to have your stored items prepared for shipping, you can do it directly using our easy to use website. You just need to select shipping destination and you will get multiple shipping methods. Your items will be categorized as <strong>"Ready To Ship & Processing Items"</strong> until shipment.'
    ]
  },
  {
    question: 'How can I arrange for pick-up or drop-off of stored items?',
    answer: [
      'You can arrange for pick-up or drop-off of your stored items by contacting customer support at least 2 business days in advance. Please note that applicable storage fees may apply.'
    ]
  },
  {
    question: 'Can I access my stored items at any time?',
    answer: [
      'Yes, you can access your stored items at any time during our operating hours. Simply contact customer support to schedule a visit or request retrieval of specific items from storage.'
    ]
  },
  {
    question: 'How are my items stored in the warehouse?',
    answer: [
      'Your items are stored securely in our warehouse facilities, organized and labeled for easy identification. We take measures to ensure proper handling and protection of your belongings while in storage.'
    ]
  },
  {
    question: 'What types of items can be stored in your facilities?',
    answer: [
      'Our storage facilities accommodate a wide range of items, including luggage, boxes, and other personal belongings. However, certain restrictions may apply to hazardous or prohibited items. Contact customer support for clarification on specific items.'
    ]
  },
  {
    question: 'Can I request special handling for my items?',
    answer: [
      'Yes, you can request special handling or storage conditions for your items, such as climate-controlled storage or fragile item handling. Additional charges may apply for specialized storage requirements.'
    ]
  },
  {
    question: 'How do I update the inventory of my stored items?',
    answer: [
      'You can update the inventory of your stored items by contacting customer support and providing any necessary information or changes. We will ensure that your inventory records are accurate and up to date.'
    ]
  },
  {
    question: 'Can I ship internationally from your storage facilities?',
    answer: [
      'Yes, we offer international shipping services for your stored items. You can select your desired destination during the shipping request process on our website. Please note that additional shipping fees and customs duties may apply for international shipments. Contact customer support for more information on international shipping options and costs.'
    ]
  }
]

const boxStorageFaqs = [
  {
    question: `<p>How Can I Get Box Storage Facilities Near Me In New York With <strong>${appName}</strong>?</p>`,
    answer: [
      `<strong>${appName}</strong> offers convenient, affordable, and secure Box storage units in NYC and Delaware.`,
      `With <strong>${appName}</strong>, you can trust in our network's reliability for site storage and convenience to store your files and belongings while you explore the city worry-free.`
    ]
  },
  {
    question: `<p>Why choose <strong>${appName}</strong> for Box storage in NYC?</p>`,
    answer: [
      `When it comes to storing your Box in New York City, <strong>${appName}</strong> offers unmatched convenience and peace of mind. Here's why you should choose our service:`,
      `- <strong>Experience:</strong> Our extensive experience in the industry enables us to provide excellent service. We know how to efficiently operate a Box storage service in a bustling metropolis like NYC.`,
      `- <strong>Guarantee:</strong> <strong>${appName}</strong> provides a guarantee for every stored item, offering coverage of up to $ $250.`,
      `- <strong>Convenient Locations:</strong> Our storage units are strategically placed throughout the city, ensuring you won't have to trek across town to retrieve your belongings.`,
      `- <strong>Flexible Hours:</strong> Store your Box anytime! <strong>${appName}</strong> ensures you can always find an available storage spot, even during odd hours.`,
      `- <strong>Personalized Support:</strong> Our dedicated customer service representatives are available 24/7. You'll speak with a real person, not a bot, who will assist you until any issue is resolved to your satisfaction.`,
      `With <strong>${appName}</strong>, storing your Box in NYC is hassle-free, secure, and backed by exceptional service.`
    ]
  },
  {
    question: `<p>Where to store my Box in NYC with <strong>${appName}</strong>?</p>`,
    answer: [
      'Enrich your travel experience with our innovative on-demand box storage solution, offering a much more affordable alternative to station lockers. With locations in New York, we provide convenient storage options for travelers.',
      'Most of our facilities are open 24/7, eliminating the need to plan your trip around bag pick-up and drop-off times. Enjoy seamless travel without the burden of bulky boxes with our reliable and accessible service.'
    ]
  },
  {
    question: 'Where are Box storage services near NYC train stations?',
    answer: [
      "For travelers navigating New York City's bustling stations, here's a comprehensive guide to Box storage options:",
      `<b>Penn Station:</b>`,
      `
        <ul>
          <li>As a major intercity railroad hub, Penn Station serves over 650,000 passengers daily.</li>
          <li>While Penn Station itself doesn't provide Box storage, ticketed Amtrak passengers can store Box for $10 per day.</li>
          <li>Non-Amtrak passengers can utilize nearby private storage services like <strong>${appName}</strong>, offering storage for $10 per day. Alternatively, storage is available at Grand Central Terminal for $20 per item.</li>
        </ul>
      `,
      `<b>Port Authority Station:</b>`,
      `
        <ul>
          <li>Port Authority Station ranks as the world's busiest bus terminal.</li>
          <li>Official storage facilities or lockers are not available, but private options nearby include Box Keeper at 357 West 36th Street ($10 per day, 2nd floor) and CBH Storage at West 46th Street ($10 per day).</li>
        </ul>
      `,
      `<b>Grand Central Terminal:</b>`,
      `
        <ul>
          <li>Despite its iconic status, Grand Central Terminal does not offer Box storage.</li>
          <li>Amtrak ticketed passengers can use Amtrak Baggage Services for $10 per day.</li>
          <li>Non-Amtrak passengers may consider nearby private storage services or explore options at Penn Station or Port Authority Station.</li>
        </ul>
      `,
      `Navigating Box storage in New York City's busiest stations may pose challenges, but with these alternative options, travelers can conveniently store their belongings while exploring the city's wonders.`
    ]
  },
  {
    question: 'Where are Box storage facilities near NYC Airports?',
    answer: [
      "Due to heightened security measures, most major airports in New York City no longer provide storage facilities or Box lockers. Here's a breakdown for each airport:",
      `<b>John F. Kennedy Airport (JFK):</b>`,
      `
        <ul>
          <li>JFK Airport offers limited Box storage services, primarily for passengers with long layovers who wish to explore the city without their bags. Prices range from $4 to $16 per day, depending on the size of the items.</li>
        </ul>
      `,
      `<b>LaGuardia Airport (LGA):</b>`,
      `
        <ul>
          <li>LaGuardia Airport does not offer box storage facilities. Passengers arriving at this airport seeking storage options must find facilities within New York City.</li>
        </ul>
      `,
      `<b>Newark Liberty International Airport (EWR):</b>`,
      `
        <ul>
          <li>Box storage services at Newark Airport are typically provided by individual airlines. Passengers should inquire with their airline about rates and any restrictions on storing Box.</li>
        </ul>
      `,
      `Given the lack of storage facilities at these airports, travelers arriving in New York City are advised to plan accordingly and arrange for alternative Box storage options within the city.`
    ]
  },
  {
    question: 'Where are Box storage facilities near NYC Museums?',
    answer: [
      "When visiting New York City's renowned art and cultural centers, it's important to find suitable Box storage options due to restrictions on extra large items within the museums. Here are the storage options near some of NYC's art institutions:",
      `<b>The Metropolitan Museum of Art (MET):</b>`,
      `
        <ul>
          <li>The MET only permits small daypacks inside the museum. Box, carry-on bags, and oversized backpacks are not allowed and cannot be stored at coat-check facilities.</li>
        </ul>
      `,
      `<b>The Museum of Modern Art (MoMA):</b>`,
      `
        <ul>
          <li>MoMA allows visitors to carry items up to 28 x 38 x 13 cm, while their storage facilities have a size limit of 36 x 56 x 23 cm. Larger items will require alternative storage solutions.</li>
        </ul>
      `,
      `<b>American Museum of Natural History:</b>`,
      `
        <ul>
          <li>The museum offers coat check areas inside the main entrance and in the lower level of the Rose Center. Coats, umbrellas, and smaller bags can be checked for $2 per person, subject to available extra space. However, large items like backpacks and suitcases are not allowed inside.</li>
        </ul>
      `
    ]
  },
  {
    question: 'What are NYC Top Attractions?',
    answer: [
      "Exploring New York City's main attractions can be difficult when you have to carry heavy boxes.Here are some options for box storage near Manhattan's key sights:",
      `<b>Empire State Building:</b>`,
      `
        <ul>
          <li>Large backpacks, suitcases, and carry-on boxes are prohibited inside the Empire State Building.</li>
        </ul>
      `,
      `<b>Statue of Liberty:</b>`,
      `
        <ul>
          <li>Visitors must pass through two screening areas before entering the monument, where large bags or prohibited items are not allowed.</li>
          <li>Small storage lockers are available at the second screening point. Consider securing box storage before reaching the first security checkpoint.</li>
        </ul>
      `,
      `<b>Central Park:</b>`,
      `
        <ul>
          <li>Official storage facilities are not available within Central Park.</li>
          <li>Visitors to Wollman and Lasker rinks can rent small lockers during skating sessions and are advised to bring their own padlock.</li>
        </ul>
      `,
      `<b>Times Square:</b>`,
      `
        <ul>
          <li>Hauling Box around Times Square can be cumbersome.</li>
          <li><strong>${appName}</strong> offers box storage near Times Square for $10 per day, without size restrictions.</li>
        </ul>
      `,
      `<b>Rockefeller Center:</b>`,
      `
        <ul>
          <li>Lockers at Rockefeller Center are reserved for rink season pass holders.</li>
          <li>Consider storing your bags at <strong>${appName}</strong> for $10 per day.</li>
        </ul>
      `,
      `<b>Madison Square Garden:</b>`,
      `
        <ul>
          <li>Madison Square Garden does not provide Box storage facilities, and large bags are discouraged.</li>
          <li><strong>${appName}</strong> offers Box storage nearby for $10 per day.</li>
          <li>By utilizing these Box storage options, you can explore New York City's iconic attractions without the inconvenience of carrying bulky bags.</li>
        </ul>
      `
    ]
  },
  {
    question: 'What are the Best things to do in NYC without Box?',
    answer: [
      'Exploring New York City without the burden of Box opens up a world of possibilities. Here are some of the best activities to enjoy in NYC:',
      `
        <ol>
          <li><b>Visit Central Park:</b> Take a leisurely stroll, enjoy a picnic, or rent a bike to explore Central Park. Don't miss attractions like the Central Park Zoo or boating on the lake.</li>
          <li><b>Explore Manhattan:</b> Dive into the diverse neighborhoods of Manhattan, from trendy boutiques in Soho to the Bohemian charm of Greenwich Village and the culinary delights of Chinatown.</li>
          <li><b>Museum Hopping:</b> Immerse yourself in art, history, and culture at renowned museums like the Metropolitan Museum of Art, MoMA, or the American Museum of Natural History.</li>
          <li><b>See a Broadway Show:</b> Experience the magic of Broadway with a wide array of theatrical performances, from dramatic plays to spectacular musicals.</li>
          <li><b>Times Square and Rockefeller Center:</b> Take in the vibrant atmosphere of Times Square and explore iconic landmarks like Rockefeller Center, where you can tour NBC studios or enjoy panoramic views from the Top of the Rock.</li>
          <li><b>Statue of Liberty and Ellis Island:</b> Embark on a ferry ride to admire the Statue of Liberty up close and explore the immigration museum on Ellis Island.</li>
          <li><b>Walk the Brooklyn Bridge:</b> Enjoy breathtaking views of the Manhattan skyline as you stroll across the historic Brooklyn Bridge.</li>
          <li><b>Food and Drink:</b> Indulge in NYC's culinary scene by visiting food markets like Chelsea Market, dining at world-class restaurants, or taking a food tour in vibrant neighborhoods.</li>
          <li><b>High Line and Hudson Yards:</b> Wander along the High Line, a unique elevated park built on a former railway line, and explore the innovative architecture and art installations of Hudson Yards.</li>
          <li><b>Shopping:</b> From luxury boutiques on Fifth Avenue to vintage treasures in Williamsburg, NYC offers unparalleled shopping experiences for every taste.</li>
        </ol>
      `,
      `These are just a few of the countless activities awaiting you in the vibrant and diverse city of New York. With endless attractions and experiences, you're sure to create unforgettable memories during your visit!`
    ]
  }
]

const golfStorageFaqs = [
  {
    question: `<p>What size and weight restrictions apply to storing my golf club with <strong>${appName}</strong>?</p>`,
    answer: [
      `<strong>${appName}</strong> imposes no size or weight restrictions, offering unparalleled flexibility for storing anything from a small to a bulky golf club.`
    ]
  },
  {
    question: `<p>How long can I store my golf club with <strong>${appName}</strong>?</p>`,
    answer: [
      `<strong>${appName}</strong> offers flexible storage solutions tailored to your needs, whether you need short-term storage for a few hours during a layover or long-term storage for an extended adventure.`
    ]
  },
  {
    question: `<p>How secure are the storage facilities at <strong>${appName}</strong>?</p>`,
    answer: [
      `Our storage facilities are monitored and equipped with safety measures to ensure the security of your belongings, providing you peace of mind while you explore the city.`
    ]
  },
  {
    question: `What should I consider when packing my golf clubs for travel?`,
    answer: [
      `Investing in a durable, well-padded travel case, and ensuring clubs are securely fastened and protected with towels or club head covers, can help safeguard your golf clubs during transit.`
    ]
  },
  {
    question: `Can I use custom storage solutions for my golf clubs?`,
    answer: [
      `Absolutely! Customized storage racks can be designed to fit your specific needs, accommodating various types of clubs and accessories in an organized and secure manner.`
    ]
  },
  {
    question: `Will proper storage practices help maintain my golf club's performance?`,
    answer: [
      `Yes, proper storage helps maintain club performance by preventing unnecessary wear and tear, preserving club integrity, and ensuring consistent performance on the course.`
    ]
  },
  {
    question: `<p>How does <strong>${appName}</strong> make storage affordable?</p>`,
    answer: [
      `<strong>${appName}</strong> offers budget-friendly rates at all our locations, making it a cost-effective solution for travelers seeking convenient and reliable golf club storage in New York City.`
    ]
  }
]
const luggageStorageFaqs = [
  {
    question: `<p>Where to store my luggage in NYC with <strong>${appName}</strong>?</p>`,
    answer: [
      `For convenient luggage storage in NYC, <strong>${appName}</strong> offers secure, affordable, and flexible storage options, including box storage, ski storage, golf club storage, and snowboard storage, with most facilities open 24/7 for ultimate travel convenience.`
    ]
  },
  {
    question: `Where Can I Find Free Luggage Storage in NYC?`,
    answer: [
      `Finding free luggage storage in NYC is rare, but some museums offer complimentary bag checks for small items, hotels often provide luggage storage for guests, and bellhops might store your bags for a generous tip, although these options come with certain risks and limitations.`
    ]
  },
  {
    question: `What are the Luggage Storage Facilities – Near NYC train stations?`,
    answer: [
      `NYC train stations like Penn Station, Port Authority, and Grand Central lack official luggage storage, but nearby private services like <strong>${appName}</strong> offer affordable luggage storage solutions at around $10 per day, ensuring convenient and secure storage options for travelers.`
    ]
  },
  {
    question: `What sort of Luggage storage Facilities are Available – Near NYC Airports?`,
    answer: [
      `JFK Airport offers limited luggage storage from $4-$16 per day, while LaGuardia has no storage facilities, and Newark Airport's storage options are typically provided by airlines. Travelers should explore NYC's various luggage storage solutions for more flexible and secure options.`
    ]
  },
  {
    question: `What are the Luggage Storage Options – Near NYC Museums?`,
    answer: [
      `NYC museums like the MET, MoMA, and the Guggenheim only allow small items to be stored, not large bags. <strong>${appName}</strong> provides secure storage solutions for large bags, making your museum visit hassle-free.`
    ]
  },
  {
    question: `What are the Luggage Storage Guidelines for - NYC Top Attractions?`,
    answer: [
      `Popular attractions in New York City, like the Empire State Building and Central Park, don't allow big bags. Popular attractions in New York City, such as the Empire State Building and Central Park, have restrictions on large bags. However, you can utilize private storage services like <strong>${appName}</strong> located nearby. These services offer safe and affordable luggage storage options, which can make your trip more convenient and enjoyable.`
    ]
  }
]
const skiStorageFaqs = [
  {
    question: `<p>What is the benefit of using <strong>${appName}'s</strong> ski storage facilities?</p>`,
    answer: [
      `<strong>${appName}'s</strong> ski storage facilities offer convenience, peace of mind, accessibility, and affordability. You can explore the city without the burden of carrying your ski gear, knowing that your belongings are secure in our monitored facilities. Our locations near major transit hubs make drop-off and pick-up easy, and we provide budget-friendly rates.`
    ]
  },
  {
    question: `Why is proper ski storage important?`,
    answer: [
      `Proper ski storage is essential for protecting your investment, extending the lifespan of your gear, and ensuring safety on the slopes. Storing your gear correctly prevents damage, wear and tear, and ensures it performs as intended, reducing the risk of accidents and injuries.`
    ]
  },
  {
    question: `How does proper storage protect my ski investment?`,
    answer: [
      `Proper storage prevents damage and unnecessary wear and tear on your ski equipment. By keeping your gear organized and stored in a safe manner, you can save money in the long run by reducing the need for repairs or replacements.`
    ]
  },
  {
    question: `What are some innovative ski storage systems available?`,
    answer: [
      `Innovative ski storage systems include wall-mounted racks, freestanding storage systems, and portable ski bags. These options help keep your gear organized, ventilated, and protected, ensuring it remains in top condition.`
    ]
  },
  {
    question: `What should I look for in a portable ski bag?`,
    answer: [
      `When choosing a portable ski bag, look for one with padded compartments and durable construction to protect your gear during travel and storage. Ensure it has enough space for your skis, poles, and any additional accessories.`
    ]
  },
  {
    question: `<p>How does <strong>${appName}'s</strong> ensure the security of my ski gear?</p>`,
    answer: [
      `<strong>${appName}</strong> provides monitored facilities equipped with safety measures to ensure the security of your belongings. This gives you peace of mind while you explore the city without worrying about your ski gear.`
    ]
  }
]
const snowboardStorageFaqs = [
  {
    question: `What is the best way to store a snowboard?</p>`,
    answer: [
      `Proper snowboard storage is essential for maintaining its condition. Options like wall-mounted racks, freestanding racks, and travel bags provide effective solutions based on your needs.`
    ]
  },
  {
    question: `What is indoor snowboard storage, and how does it work?`,
    answer: [
      `Indoor snowboard storage refers to storing your snowboard inside your home or in a designated storage area. It typically involves using racks, hooks, or storage systems to keep the snowboard organized and protected from damage.`
    ]
  },
  {
    question: `How does a wall-mounted ski and snowboard rack differ from other storage options?`,
    answer: [
      `A wall-mounted rack allows you to store your snowboard vertically against a wall, saving floor space and keeping it easily accessible. It's ideal for those with limited space who want a convenient storage solution.`
    ]
  },
  {
    question: `<p>Are there any weight or size restrictions for storing a snowboard with <strong>${appName}</strong>?</p>`,
    answer: [
      `No, <strong>${appName}</strong> imposes no size or weight restrictions on snowboard storage, providing travelers with flexibility and convenience.`
    ]
  },
  {
    question: `What are the benefits of using a snowboard wall mount rack?`,
    answer: [
      `A snowboard wall mount rack helps maximize space by storing your snowboard vertically on a wall. It keeps the snowboard organized, easily accessible, and protected from damage.`
    ]
  },
  {
    question: `Can I store my snowboard gear along with my snowboard?`,
    answer: [
      `Yes, many snowboard storage solutions can accommodate gear like boots, helmets, and clothing. Freestanding racks and travel bags often offer additional storage space for gear.`
    ]
  }
]

export {
  dashboardFaqs,
  myShipmentFaqs,
  myStorageFaqs,
  luggageStorageFaqs,
  boxStorageFaqs,
  golfStorageFaqs,
  skiStorageFaqs,
  snowboardStorageFaqs
}
